import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DataGridConfig } from '@app/shared/components/data-grid/data-grid-config';

@Component({
  selector: 'db-insert-question-dialog',
  templateUrl: './insert-question-dialog.component.html',
  styleUrls: ['./insert-question-dialog.component.scss']
})
export class InsertQuestionDialogComponent implements OnInit {
  dataGridConfig: DataGridConfig;

  selectedRowData: any[] = [];
  rowData: any = [];

  constructor(
    private insertQuestionDialogRef: MatDialogRef<InsertQuestionDialogComponent>
  ) { }

  ngOnInit() {
    this.initializeRowData();
    this.configureGrid();
  }

  insertText() {
    const textToInsert = this.selectedRowData[0].questionName;

    this.insertQuestionDialogRef.close(textToInsert);
  }

  initializeRowData() {
    this.rowData = [
      {
        questionName: 'Some question name?'
      },
      {
        questionName: 'Some other question name?'
      }
    ];
  }

  configureGrid() {
    this.dataGridConfig = {
      columnDefs: [
        {
          headerName: 'Question',
          field: 'questionName',
          minWidth: 200
        }
      ],
      defaultColDef: {
        checkboxSelection: this.isFirstColumn
      },
      rowSelection: 'single',
      gridCompact: true
    };
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  selectedRows($event) {
    this.selectedRowData = $event;
  }

  closeDialog() {
    this.insertQuestionDialogRef.close(false);
  }

}
